import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtensionGuideDialogComponent } from './components/extension-guide-dialog/extension-guide-dialog.component';
import { ExtensionGuidePanelComponent } from './components/extension-guide-panel/extension-guide-panel.component';
import { ExtensionVisualLinkButtonComponent } from './components/visual-link-button/visual-link-button.component';

import { TranslateModule } from '../translate.module';
import { AngularSharedComponentsModule } from '@monsido/angular-shared-components';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    declarations: [
        ExtensionGuideDialogComponent,
        ExtensionGuidePanelComponent,
        ExtensionVisualLinkButtonComponent,
    ],
    imports: [
        CommonModule,
        NgbTooltipMfeModule,
        TranslateModule,
        AngularSharedComponentsModule,
    ],
    exports: [
        ExtensionGuideDialogComponent,
        ExtensionGuidePanelComponent,
        ExtensionVisualLinkButtonComponent,
    ],
})
export class ExtensionModule {}
